import { render, staticRenderFns } from "./ModalAdmin.vue?vue&type=template&id=03491df3"
import script from "./ModalAdmin.vue?vue&type=script&lang=js"
export * from "./ModalAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03491df3')) {
      api.createRecord('03491df3', component.options)
    } else {
      api.reload('03491df3', component.options)
    }
    module.hot.accept("./ModalAdmin.vue?vue&type=template&id=03491df3", function () {
      api.rerender('03491df3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/complementainfo/ModalAdmin.vue"
export default component.exports